<template>
    <div>
        <task-lists
            displaymode="standalone"
        ></task-lists>
    </div>
</template>
